import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selector', 'experience']

  connect() {
    // If no selector exists (single package), show all experiences
    if (!this.hasSelectorTarget) {
      this.showAllExperiences()
      return
    }

    // If only one package option, show all experiences and hide selector
    const packageOptions = this.selectorTarget.options.length
    if (packageOptions <= 2) { // 1 option + "Select a package" placeholder
      this.selectorTarget.closest('.package-selector-wrapper').style.display = 'none'
      this.showAllExperiences()
    }
  }

  filterExperiences() {
    // TODO: Implement package-specific filtering when resources available
    // For now, show all experiences when any package is selected
    // Future: Use data-package-ids/data-package-id attributes to filter by selected package
    this.showAllExperiences()
  }

  showAllExperiences() {
    this.experienceTargets.forEach(experience => {
      experience.classList.remove('hidden')
    })
  }
}
